document.addEventListener('DOMContentLoaded', function () {

  if (document.querySelectorAll('.variant-images-cls span').length) {
    document.querySelectorAll('.additional-class').forEach(function (elem) {
      elem.remove();
    });
  
    var varoo = document.querySelector('[name="id"]').value;
  
    document.querySelectorAll('.variant-images-cls span').forEach(function (span) {
      var vid = span.getAttribute('data-id');
  
      if (varoo === vid) {
        var vimg = span.getAttribute('data-image');
  
        var indx = parseInt(document.querySelector('.slider--product__holder .slider--product').getAttribute('data-bstr-slider-current'), 10);
  
        var targetSlide = document.querySelectorAll('.slider--product__holder .slider--product .slide--product')[indx];
  
        if (!targetSlide.querySelector('img.additional-class')) {
          var originalImg = targetSlide.querySelector('img');
          var appendimg = originalImg.cloneNode(true);
  
          originalImg.classList.add('hide');
  
          appendimg.setAttribute('src', vimg);
          appendimg.classList.add('additional-class');
  
          targetSlide.appendChild(appendimg);
  
          appendimg.classList.remove('hide');
        }
      }
    });
  }

})


$(document).ready(function () {
  $(document).on('click', '.swatches__holder', function () {
    $('.additional-class').remove();

    var varoo = $('[name="id"]').val();

    $('.variant-images-cls span').each(function () {
      var vid = $(this).attr('data-id');

      if (varoo == vid) {
        var vimg = $(this).attr('data-image');

        var indx = parseInt($('.slider--product__holder .slider--product').attr('data-bstr-slider-current'), 10);

        var targetSlide = $('.slider--product__holder .slider--product .slide--product:eq(' + indx + ')');

        if (!targetSlide.find('img.additional-class').length) {
          var appendimg = targetSlide.find('img').first().clone();
          targetSlide.find('img').first().addClass('hide');
          appendimg.attr('src', vimg);
          appendimg.addClass('additional-class');
          targetSlide.append(appendimg);
          $('.additional-class').removeClass('hide');
        }
      }
    });
  });

  $('.product__row .gallery__default .gallery__thumbnail[data-media-type="image"] img').click(function(){
    $('.additional-class').remove();
    $('.slider--product__holder .slider--product .slide--product img').removeClass('hide');
  })

  // if($('.variant-images-cls span').length){

  //   $('.additional-class').remove();

  //   var varoo = $('[name="id"]').val();

  //   $('.variant-images-cls span').each(function () {
  //     var vid = $(this).attr('data-id');

  //     if (varoo == vid) {
  //       var vimg = $(this).attr('data-image');

  //       var indx = parseInt($('.slider--product__holder .slider--product').attr('data-bstr-slider-current'), 10);

  //       var targetSlide = $('.slider--product__holder .slider--product .slide--product:eq(' + indx + ')');

  //       if (!targetSlide.find('img.additional-class').length) {
  //         var appendimg = targetSlide.find('img').first().clone();
  //         targetSlide.find('img').first().addClass('hide');
  //         appendimg.attr('src', vimg);
  //         appendimg.addClass('additional-class');
  //         targetSlide.append(appendimg);
  //         $('.additional-class').removeClass('hide');
  //       }
  //     }
  //   });
  // }

  
  
});
